import { render } from "./FrancaisSimpleMaterialDetails.vue?vue&type=template&id=9bee7110"
import script from "./FrancaisSimpleMaterialDetails.vue?vue&type=script&lang=js"
export * from "./FrancaisSimpleMaterialDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__